import { useQuery } from '@tanstack/react-query';
import { authAPI } from '../api/endpoints';
import type { EmailSnippet } from '../types';

/**
 * The user's "/" snippet library (see docs/EMAIL_SNIPPETS.md).
 *
 * Reads the same `['current-user']` query the profile page writes after saving settings, so an
 * edit there reaches every open editor without a refetch.
 */
export function useEmailSnippets(enabled = true): EmailSnippet[] {
  const { data } = useQuery({
    queryKey: ['current-user'],
    queryFn: async () => {
      const response = await authAPI.me();
      return response.data;
    },
    enabled,
    staleTime: 5 * 60 * 1000,
  });

  return data?.settings?.email_snippets ?? [];
}
